import { render } from "./CommonInput.vue?vue&type=template&id=5ab7ec1a&scoped=true&ts=true"
import script from "./CommonInput.vue?vue&type=script&lang=ts"
export * from "./CommonInput.vue?vue&type=script&lang=ts"

import "./CommonInput.vue?vue&type=style&index=0&id=5ab7ec1a&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab7ec1a"]])

export default __exports__